"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMCallCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../../node/NodeGuards");
const VMOpCode_1 = require("../../../../enums/vm-transformers/VMOpCode");
let VMCallCompiler = class VMCallCompiler {
    compileCallExpression(node, context) {
        if (node.type === 'CallExpression' && node.optional) {
            this.compileOptionalCall(node, context);
            return;
        }
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.callee)) {
            this.compileMethodCall(node, context);
        }
        else {
            this.compileFunctionCall(node, context);
        }
    }
    compileNewExpression(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isSuperNode(node.callee)) {
            builder.pushUndefined();
            return;
        }
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.callee);
        this.emitCallArguments(node.arguments, context);
        builder.loadConst(node.arguments.length);
        builder.callNew(node.arguments.length);
    }
    containsAssignmentExpression(expr) {
        if (NodeGuards_1.NodeGuards.isAssignmentExpressionNode(expr)) {
            return true;
        }
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(expr) && !NodeGuards_1.NodeGuards.isSuperNode(expr.object)) {
            return this.containsAssignmentExpression(expr.object);
        }
        return false;
    }
    compileMethodCall(node, context) {
        var _a, _b, _c, _d, _e;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const callee = node.callee;
        if (NodeGuards_1.NodeGuards.isSuperNode(callee.object)) {
            this.emitCallArguments(node.arguments, context);
            builder.this();
            builder.dup();
            if (callee.computed) {
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(callee.property);
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(callee.property)) {
                const propIndex = context.constantPool.add(callee.property.name);
                builder.loadConstByIndex(propIndex);
            }
            builder.emitRaw({ op: VMOpCode_1.VMOpCode.GET_SUPER_PROP, arg: 0 });
            builder.loadConst(node.arguments.length);
            builder.callMethod(node.arguments.length);
            return;
        }
        const needsLeftToRightEval = this.containsAssignmentExpression(callee.object);
        if (!needsLeftToRightEval) {
            this.emitCallArguments(node.arguments, context);
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(callee.object);
            builder.dup();
            if (callee.computed) {
                (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(callee.property);
                builder.getComputed();
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(callee.property)) {
                const propIndex = context.constantPool.add(callee.property.name);
                builder.getPropertyByName(propIndex);
            }
            builder.loadConst(node.arguments.length);
            builder.callMethod(node.arguments.length);
        }
        else {
            (_d = context.dispatch) === null || _d === void 0 ? void 0 : _d.expression(callee.object);
            builder.dup();
            if (callee.computed) {
                (_e = context.dispatch) === null || _e === void 0 ? void 0 : _e.expression(callee.property);
                builder.getComputed();
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(callee.property)) {
                const propIndex = context.constantPool.add(callee.property.name);
                builder.getPropertyByName(propIndex);
            }
            if (node.arguments.length > 0) {
                const baseLocalVarIndex = Math.max(context.localVariables.size, context.maxLocals);
                const methodActualIndex = context.parameters.size + baseLocalVarIndex;
                const objActualIndex = context.parameters.size + baseLocalVarIndex + 1;
                context.maxLocals = baseLocalVarIndex + 2;
                builder.storeLocal(methodActualIndex);
                builder.storeLocal(objActualIndex);
                this.emitCallArguments(node.arguments, context);
                builder.loadLocal(objActualIndex);
                builder.loadLocal(methodActualIndex);
            }
            builder.loadConst(node.arguments.length);
            builder.callMethod(node.arguments.length);
        }
    }
    compileFunctionCall(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isSuperNode(node.callee)) {
            builder.loadGlobalByName('__$$constructor$$__');
            builder.getProp('__$$super$$__');
            this.emitCallArguments(node.arguments, context);
            builder.loadConst(node.arguments.length);
            builder.emitRaw({ op: VMOpCode_1.VMOpCode.SUPER_CALL, arg: 0 });
            return;
        }
        this.emitCallArguments(node.arguments, context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.callee);
        builder.loadConst(node.arguments.length);
        builder.call(node.arguments.length);
    }
    compileOptionalCall(node, context) {
        var _a, _b, _c;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.callee)) {
            const callee = node.callee;
            this.emitCallArguments(node.arguments, context);
            if (callee.object.type === 'Super') {
                builder.pushUndefined();
                return;
            }
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(callee.object);
            builder.dup();
            if (callee.computed) {
                if (callee.property.type === 'PrivateIdentifier') {
                    builder.pushUndefined();
                    return;
                }
                (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(callee.property);
                if (callee.optional) {
                    builder.getComputedOptional();
                }
                else {
                    builder.getComputed();
                }
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(callee.property)) {
                const propIndex = context.constantPool.add(callee.property.name);
                const opcode = callee.optional ? VMOpCode_1.VMOpCode.GET_OPTIONAL : VMOpCode_1.VMOpCode.GET_PROP;
                builder.emitRaw({ op: opcode, arg: propIndex });
            }
            this.emitOptionalCallWithFallback(node.arguments.length, true, 1, context);
        }
        else {
            this.emitCallArguments(node.arguments, context);
            if (node.callee.type === 'Super') {
                builder.pushUndefined();
                return;
            }
            (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(node.callee);
            this.emitOptionalCallWithFallback(node.arguments.length, false, 0, context);
        }
    }
    emitCallArguments(args, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        for (const arg of args) {
            if (NodeGuards_1.NodeGuards.isSpreadElementNode(arg)) {
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(arg.argument);
                builder.spread();
            }
            else {
                (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(arg);
            }
        }
    }
    emitOptionalCallWithFallback(argCount, isMethodCall, extraPopsOnSkip, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        builder.dup();
        builder.pushUndefined();
        builder.strictEqual();
        const skipCallLabel = builder.jumpIfTrue();
        builder.loadConst(argCount);
        if (isMethodCall) {
            builder.callMethod(argCount);
        }
        else {
            builder.call(argCount);
        }
        const endLabel = builder.jump();
        skipCallLabel.patchToHere();
        builder.pop();
        for (let i = 0; i < extraPopsOnSkip; i++) {
            builder.pop();
        }
        for (let i = 0; i < argCount; i++) {
            builder.pop();
        }
        builder.pushUndefined();
        endLabel.patchToHere();
    }
};
exports.VMCallCompiler = VMCallCompiler;
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils),
    __metadata("design:type", typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object)
], VMCallCompiler.prototype, "vmCompilerUtils", void 0);
exports.VMCallCompiler = VMCallCompiler = __decorate([
    (0, inversify_1.injectable)()
], VMCallCompiler);
